import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
	useEffect,
} from "react";
import { useComplexState } from "use-complex-state";
import { AssetReducer } from "../reducers/AssetReducer";

const AssetContext = createContext({
	state: AssetReducer.getInitialState(),
	actions: AssetReducer.actions,
});

export const useAssetContext = () => useContext(AssetContext);

export const AssetProvider = ({
	children,
	plantAssetId = 1,
}: { children: ReactNode; plantAssetId?: number }) => {
	const [state, actions] = useComplexState({
		initialState: {
			areasList: [],
			allAssets: [],
			plantAssetId,
		},
		reducers: AssetReducer.caseReducers,
	});

	return (
		<AssetContext.Provider value={{ state, actions }}>
			{children}
		</AssetContext.Provider>
	);
};
